module.exports = __webpack_public_path__ + "static/footer-4-ad97d59ee76841e962276d155c287c58.mp4";